import {ChangeDetectorRef, EmbeddedViewRef, Pipe, PipeTransform, Type} from '@angular/core';

// eslint-disable-next-line no-unused-vars
type OmitFirstArg<F> = F extends (x: any, ...args: infer P) => infer R ? (...args: P) => R : never;

type First<T> = T extends [infer U, ...any[]] ? U : any;

type TailArguments<F> = [..._: Parameters<OmitFirstArg<F>>, ...args: any];


@Pipe({
  name: 'ngGenericPipe',
  pure: true
})
export class NgGenericPipe implements PipeTransform {
  private context: any;

  constructor(cdRef: ChangeDetectorRef) {
    // retrive component instance (this is a workaround)
    this.context = (cdRef as EmbeddedViewRef<Type<any>>).context;
  }

  // eslint-disable-next-line no-unused-vars
  public transform<T, K extends (...args: any) => ReturnType<K>>(
    headArgument: First<Parameters<K>>,
    fnReference: K,
    ...tailArguments: TailArguments<K>
  ): ReturnType<K> {
    return fnReference.apply(this.context, [headArgument, ...tailArguments]);
  }
}
